/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import Dialog from '@material-ui/core/Dialog'
import PropTypes from 'prop-types'
import React from 'react'

import { noop } from '../../helpers/utils'

/**
 * Defines a component Confirm Box
 * @param props
 * @returns {*}
 * @constructor
 */

const CustomDialog = ({ children, ...props }) => {
  const { close, ...rest } = props
  const handleClose = function (_, reason) {
    if (reason === 'backdropClick') {
      return
    }
    close()
  }
  /**
   * Render JSX of  confirm Box modal
   */
  return (
    <Dialog onClose={handleClose} {...rest}>
      {children}
    </Dialog>
  )
}

CustomDialog.propTypes = {
  close: PropTypes.func,
  children: PropTypes.node,
}
CustomDialog.defaultProps = {
  children: null,
  close: noop,
}

/**
 /**
 * Confirm Box modal component
 */
export default CustomDialog
